<template>
  <!-- <div v-if="purchaseId" class="btn text-cursor m-l-16" @click="goPage"> -->
  <div class="btn text-cursor m-l-16" @click="goPage">
    <i class="iconfont icon--_fenxi"></i>
    采购单位分析
  </div>
</template>

<script>
import { getCompaniesExistApi } from '@/api/value-added-service'

export default {
  name: 'PurchaseAnalysisBtn',

  props: {
    companyName: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      purchaseId: ''
    }
  },

  computed: {
    // 根据路由判断采购类型，招标、询比、竞价
    procurementName() {
      return 0
    }
  },
  watch: {
    companyName: {
      handler: function(val) {
        val && this.getCompanyList()
      },
      immediate: true
    }
  },

  methods: {
    // 查询公司是否存在
    getCompanyList() {
      const params = {
        companyNames: this.companyName
      }
      getCompaniesExistApi(params)
        .then(res => {
          this.purchaseId = Object.values(res.data)[0] || ''
        })
        .catch(err => {
          this.$message.error(err.message || '获取失败')
        })
    },
    // 跳转至标前狗采购单位分析
    goPage() {
      const url =
        process.env.VUE_APP_BIDDOG_URL +
        `/purchaser-analysis/${this.purchaseId}/detail`
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 4px 10px;
  background: #EDF6FF;
  color: $primary-color;
  border-radius: 4px;
  margin-top: -8px;
}
</style>
